import Fecth from './fetch';
import qs from 'qs';
import { dateFormat } from '../utils/utils';
import { SchoolApiPath } from './config';

export default class schoolFetch {
    constructor() {
        this.fetch = new Fecth(SchoolApiPath, 'school');
    }
    // 获取所有课程列表
    getAllCourse() {
        return this.fetch.getRequest('/course/list', null);
    }
    // 获取所有课程列表
    getCourse(id,attach) {
        return this.fetch.getRequest('/course', `courseId=${id}&attach=${attach}`);
    }
    // 获取我的课程
    getMyCourse(attach) {
        return this.fetch.getRequest('/trade/order/course/list', `attach=${attach}`);
    }
    // 查询自己和课程的关系
    getMineCourse(id) {
        return this.fetch.getRequest('/course/mine/status', `courseId=${id}`);
    }
    // 购买课程创建订单/trade/order/course/create
    createCourse(id,toPay) {
        return this.fetch.postRequest('/trade/order/course/create', `courseId=${id}&toPay=${toPay}`);
    }
    // 购买课程第二步
    pay(item) {
        return this.fetch.postRequest('/trade/order/pay/public', `orderId=${item.orderId}&endUrl=${window.location.origin}`);
    }
    // confirm
    confirmPay(sitePayOrder) {
        return this.fetch.putRequest('/trade/order/status/change', `sitePayOrder=${sitePayOrder}`);
    }
    // 去学习
    toLearn(id) {
        return this.fetch.getRequest('/study/course/access', `courseId=${id}`);
    }

  // 获取站点接口版本信息
  getSchoolSiteVersion() {
    return this.fetch.getRequest( '/site/version');
  }
}



// WEBPACK FOOTER //
// ./src/fetch/school.js